export const PLANS_ROUTE = ['/plus/digital', '/plus/premium'];
export const ROUTE_PLUS_PLANS = '/plus/:planType?';
export const ROUTE_PLUS_PLANS_REVIEW = `${ROUTE_PLUS_PLANS}/review`;
export const ROUTE_PLUS_PLANS_REVIEW_CONFIRMED = `${ROUTE_PLUS_PLANS}/review/confirmed`;
export const ROUTE_PLUS_PLANS_ALREADY_PLUS = `${ROUTE_PLUS_PLANS}/already-plus`;
export const ROUTE_PLUS_PLANS_SCHEDULE = `${ROUTE_PLUS_PLANS}/schedule`;
export const ROUTE_PLUS_PLANS_CONTRACT_BINDING = `${ROUTE_PLUS_PLANS}/contract`;
export const ROUTE_PLUS_PLANS_LOGIN = `${ROUTE_PLUS_PLANS}/login`;
export const AVAILABLE_PLUS_PLANS = ['digital', 'premium'];
